import type { AccountContextValue } from '~/context/account/AccountContext'

/** The balance an order is validated against, depending on household redemption availability */
export const getRedeemableAviosBalance = (
  { aviosBalance, spendableAviosBalance }: AccountContextValue,
  isHouseholdRedemptionEnabled: boolean
): number | undefined => (isHouseholdRedemptionEnabled ? spendableAviosBalance : aviosBalance)
